import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { SubscriptionListenerComponent } from 'src/app/angular-wallet-base/SubscriptionListenerComponent';
import { emailPattern } from 'src/app/angular-wallet-base/utils';
import { StorageService } from 'src/app/angular-wallet-base/services/storage.service';
import { LODE_DEBIT_CARD_EMAIL_SUBSCRIPTION } from 'src/app/angular-wallet-base/constants';
import { NavController } from '@ionic/angular';
import { EmailService } from 'src/app/angular-wallet-base/services/email.service';


@Component({
  selector: 'app-lode-debit-card-home',
  templateUrl: './lode-debit-card-home.component.html',
  styleUrls: ['./lode-debit-card-home.component.scss'],
})
export class LodeDebitCardHomeComponent extends SubscriptionListenerComponent implements OnInit {

  isDesktopMode: boolean;
  sendForm: FormGroup;
  isEmailAvailable: boolean = false;
  showSuccess: boolean = false;
  formErrors = {
    emailError: ''
  };

  constructor(
    protected store: Store<AppState>,
    public appMode: AppModeService,
    private formBuilder: FormBuilder,
    private emailService: EmailService,
    private storage: StorageService,
    private nav: NavController) {
    super(store);
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  async ngOnInit() {
    await this.buildForm();
  }

  ionViewWillEnter() {
    this.checkIsRegistered();
  }

  async checkIsRegistered() {
    const email = await this.storage.get(LODE_DEBIT_CARD_EMAIL_SUBSCRIPTION);
    this.isEmailAvailable = email ? true : false;
  }

  async buildForm() {
    this.sendForm = this.formBuilder.group({
      email: ['', [Validators.required,
      Validators.pattern(emailPattern)]],
    });
  }

  async subscribeEmail() {
    try {
      const email = this.sendForm.value.email;
      const response = await this.emailService.emailSubscriptionRequest(email);

      // response is returned from the mailchimp api as result & msg
      if (response && response.result && response.result === 'success') {
        this.isEmailAvailable = true;
        this.showSuccess = true;
        this.storage.set(LODE_DEBIT_CARD_EMAIL_SUBSCRIPTION, JSON.stringify(email));
        Logger.info('email subscription success', response);
      } else if (response && response.result && response.result !== 'success') {
        this.formErrors.emailError = response.msg;
        Logger.error('email subscription error', response.msg);
      }
    } catch (error) {
      Logger.error('Failed to subscribe : ', error);
      this.formErrors.emailError = `Failed to subscribe email, please try again later!!`;
    }
  }

  focusEmail() {
    this.formErrors.emailError = '';
  }

  backToHomePage() {
    this.nav.back();
  }
}
